import React, { useState } from 'react';
import { Button } from '@mantine/core';
import { PdfSignatureInfo } from '../model/PdfSignatureInfo';
import { repositorySign } from '../_base/_const/_constVar';

interface CheckSignProps {
  fileUrl: string;
}

interface MessageResponse<T> {
  httpStatusCode: number;
  success: boolean;
  message?: string;
  data?: T;
}

export const CheckSign: React.FC<CheckSignProps> = ({ fileUrl }) => {
  const [signatures, setSignatures] = useState<PdfSignatureInfo[]>([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const checkSignatures = async () => {
    setIsLoading(true);
    try {
      const encodedUrl = encodeURIComponent(fileUrl);
      const urlApi = `/api/v1/Home/VerifySignature?fileUrl=${encodedUrl}`;
      
      var resSign = await repositorySign.get<MessageResponse<PdfSignatureInfo[]>>(urlApi);
      
      if (resSign && resSign.httpStatusCode === 200) {
        if (!resSign.success) {
          // NotificationExtension.Fails(resSign.message ?? "Thất bại !");
          console.error(resSign.message ?? "Thất bại !");
        } else {
          const signatureData = resSign.data || [];
          setSignatures(Array.isArray(signatureData) ? signatureData : [signatureData]);
          setIsPopupOpen(true);
        }
      } else {
        console.error('Failed to verify signatures');
        // NotificationExtension.Fails("Không thể kiểm tra chữ ký số");
      }
    } catch (error) {
      console.error('Error checking signatures:', error);
      // NotificationExtension.Fails("Lỗi khi kiểm tra chữ ký số");
    } finally {
      setIsLoading(false);
    }
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSignatures([]);
  };

  const viewSignatureDetails = async (signature: PdfSignatureInfo) => {
    // Call API for detailed signature information if needed
    console.log('Viewing signature details:', signature);
  };

  return (
    <>
      <Button 
        onClick={checkSignatures}
        disabled={isLoading}
        loading={isLoading}
        className="btn-check-signature"
      >
        Kiểm tra chữ ký số
      </Button>

      {isPopupOpen && (
        <div 
          className="popup-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            paddingTop: '50px',
            zIndex: 1000
          }}
          onClick={closePopup}
        >
          <div 
            className="popup-content"
            style={{
              backgroundColor: 'white',
              padding: window.innerWidth <= 768 ? '15px' : '30px',
              borderRadius: '8px',
              maxWidth: '95vw',
              maxHeight: '90vh',
              overflow: 'auto',
              minWidth: '280px',
              width: window.innerWidth <= 768 ? '90vw' : window.innerWidth <= 1024 ? '80vw' : '70vw'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ fontSize: window.innerWidth <= 768 ? '18px' : '24px', margin: 0 }}>Danh sách chữ ký số</h3>
              <button 
                onClick={closePopup}
                style={{ 
                  background: 'none', 
                  border: 'none', 
                  fontSize: window.innerWidth <= 768 ? '20px' : '24px', 
                  cursor: 'pointer',
                  padding: '5px'
                }}
              >
                ×
              </button>
            </div>

            {signatures.length === 0 ? (
              <p style={{ fontSize: window.innerWidth <= 768 ? '14px' : '16px' }}>Không tìm thấy chữ ký số nào trong file.</p>
            ) : (
              <div>
                {signatures.map((signature, index) => (
                  <div 
                    key={index}
                    style={{
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      padding: window.innerWidth <= 768 ? '10px' : '15px',
                      marginBottom: '10px',
                      backgroundColor: signature.isValid ? '#f8f9fa' : '#fff3cd'
                    }}
                  >
                    <div>
                      <div style={{ width: '100%' }}>
                        <h5 style={{ 
                          margin: '0 0 10px 0',
                          fontSize: window.innerWidth <= 768 ? '14px' : '16px',
                          display: 'flex',
                          flexWrap: 'wrap',
                          alignItems: 'center',
                          gap: '8px'
                        }}>
                          <span>{signature.name || 'Không có tên'}</span>
                          <span 
                            style={{
                              padding: '2px 8px',
                              borderRadius: '12px',
                              fontSize: window.innerWidth <= 768 ? '10px' : '12px',
                              backgroundColor: signature.isValid ? '#28a745' : '#dc3545',
                              color: 'white',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            {signature.isValid ? 'Hợp lệ' : 'Không hợp lệ'}
                          </span>
                        </h5>
                        
                        {/* Certificate Status Badges */}
                        <div style={{ 
                          marginBottom: '10px',
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: '4px'
                        }}>
                          {signature.isSelfSigned && (
                            <span style={{
                              padding: '2px 6px',
                              borderRadius: '8px',
                              fontSize: window.innerWidth <= 768 ? '9px' : '11px',
                              backgroundColor: '#ffc107',
                              color: '#212529'
                            }}>
                              Chứng thư tự ký
                            </span>
                          )}
                          {signature.isExpired && (
                            <span style={{
                              padding: '2px 6px',
                              borderRadius: '8px',
                              fontSize: window.innerWidth <= 768 ? '9px' : '11px',
                              backgroundColor: '#dc3545',
                              color: 'white'
                            }}>
                              Hết hạn
                            </span>
                          )}
                          {/* {!signature.isTrustedCA && (
                            <span style={{
                              padding: '2px 6px',
                              borderRadius: '8px',
                              fontSize: window.innerWidth <= 768 ? '9px' : '11px',
                              backgroundColor: '#6c757d',
                              color: 'white'
                            }}>
                              CA không tin cậy
                            </span>
                          )} */}
                        </div>
                        
                        <div style={{ fontSize: window.innerWidth <= 768 ? '12px' : '14px', color: '#666' }}>
                          {signature.signer && <p style={{ margin: '5px 0', wordBreak: 'break-word' }}><strong>Người ký:</strong> {signature.signer}</p>}
                          {signature.signingTime && (
                            <p style={{ margin: '5px 0' }}><strong>Thời gian:</strong> {new Date(signature.signingTime).toLocaleString('vi-VN')}</p>
                          )}
                          {signature.location && <p style={{ margin: '5px 0', wordBreak: 'break-word' }}><strong>Vị trí:</strong> {signature.location}</p>}
                          {signature.reason && <p style={{ margin: '5px 0', wordBreak: 'break-word' }}><strong>Lý do:</strong> {signature.reason}</p>}
                          {signature.contactInfo && <p style={{ margin: '5px 0', wordBreak: 'break-word' }}><strong>Liên hệ:</strong> {signature.contactInfo}</p>}
                          
                          {/* Validation Message with proper formatting */}
                          {signature.validationMessage && (
                            <div style={{ 
                              margin: '10px 0',
                              padding: window.innerWidth <= 768 ? '8px' : '10px',
                              backgroundColor: '#f8f9fa',
                              borderRadius: '4px',
                              borderLeft: `4px solid ${signature.isValid ? '#28a745' : '#dc3545'}`
                            }}>
                              <strong style={{ fontSize: window.innerWidth <= 768 ? '11px' : '13px' }}>Chi tiết xác thực:</strong>
                              <div style={{ 
                                marginTop: '5px', 
                                lineHeight: '1.4',
                                fontSize: window.innerWidth <= 768 ? '11px' : '13px'
                              }}>
                                {signature.validationMessage.split('|').map((msg, msgIndex) => (
                                  <div key={msgIndex} style={{ marginBottom: '3px', wordBreak: 'break-word' }}>
                                    • {msg.trim()}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                          
                          {/* Certificate Details */}
                          <div style={{ 
                            margin: '10px 0',
                            padding: window.innerWidth <= 768 ? '6px' : '8px',
                            backgroundColor: '#e9ecef',
                            borderRadius: '4px',
                            fontSize: window.innerWidth <= 768 ? '11px' : '13px'
                          }}>
                            <strong>Thông tin chứng thư:</strong>
                            <div style={{ marginTop: '5px' }}>
                              <div>• Chứng thư tự ký: {signature.isSelfSigned ? 'Có' : 'Không'}</div>
                              <div>• Tình trạng: {signature.isExpired ? 'Hết hạn' : 'Còn hiệu lực'}</div>
                              {/* <div>• CA tin cậy: {signature.isTrustedCA ? 'Có' : 'Không'}</div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CheckSign;

